module.exports = __webpack_public_path__ + "img/loopcad-mj8.735fb0ec.png";